import { useMemo, useEffect, useState } from 'react';

import { loadProjectSitesAreas } from 'components/admin/projects/details/project-site-area/store/action';
import { setShowAddProjectAreaModal, submitProjectArea } from './store/action';

const initialForm = {
  name: '',
  siteId: null,
  areaId: null,
  delete: false,
};

const useAddProjectAreaModal = (props) => {
  const {
    dispatch,
    currentProject,
    projectSites,
    show,
    edit,
    closeCallback,
    selectedSite,
  } = props;

  const getInitialForm = () => {
    const res = { ...initialForm };
    if (selectedSite) res.siteId = selectedSite;
    return res;
  };
  const [form, setForm] = useState(getInitialForm());

  useEffect(() => {
    if (show) setForm(getInitialForm());
    if (currentProject.id && show) {
      if (!projectSites || projectSites.projectId !== currentProject.id) {
        dispatch(loadProjectSitesAreas(currentProject.id));
      }
    }
  }, [show]);

  const { siteOptions, areaOptions } = useMemo(() => {
    const siteOptions = [];
    const areaOptions = [];

    if (
      projectSites &&
      projectSites.sites &&
      currentProject &&
      projectSites.projectId === currentProject.id
    ) {
      projectSites.sites.forEach((s) => {
        let label = s.name;
        if (s.number && s.number !== '0') label = `#${s.number} - ${label}`;
        siteOptions.push({ value: s.id, label });
      });

      projectSites.areas.forEach((a) => {
        let label = a.name;
        if (a.project_site_number && a.project_site_number !== '0')
          label += ` - #${a.project_site_number} - ${a.project_site_name}`;
        else label += ` - ${a.name}`;
        areaOptions.push({ value: a.id, label });
      });
    }

    return { siteOptions, areaOptions };
  }, [projectSites]);

  const handleClose = (submitted) => {
    dispatch(setShowAddProjectAreaModal(false));
    if (typeof closeCallback === 'function') closeCallback(submitted);
  };
  const handleFormChange = (values) => {
    const result = { ...form, ...values };

    if (edit && values.areaId) {
      if (projectSites && projectSites.areas) {
        const area = projectSites.areas.find((s) => s.id === values.areaId);
        if (area) {
          result.name = area.name;
          result.siteId = area.project_site_id;
        }
      }
    }

    setForm(result);
  };

  const validateForm = () => {
    const errors = {};
    if (!form.delete && (!form.name || form.name.length === 0))
      errors.name = true;
    if (!edit && !form.siteId) errors.siteId = true;
    if (edit && !form.areaId) errors.areaId = true;
    return errors;
  };

  const onSave = () => {
    const data = { ...form };
    delete form.errors;
    dispatch(submitProjectArea(currentProject.id, data)).then((response) => {
      if (response.ok) handleClose(true);
    });
  };

  const handleSubmit = () => {
    const errors = validateForm();
    if (Object.keys(errors).length > 0) handleFormChange({ errors });
    else onSave();
  };

  return {
    handleClose,
    handleSubmit,
    handleFormChange,
    form,
    invalidForm: form.errors && Object.keys(form.errors).length > 0,
    siteOptions,
    areaOptions,
  };
};

export default useAddProjectAreaModal;
